define(['jquery', 'mainGtm', 'globalVars'], ($, gtm, { $document, $body }) => {
    return {
        init() {
            this.initCache();
            this.initEvents();
        },

        initCache() {
            this.blockProductAnalytics = '[data-type=product-analytics]';
            this.$btnCurrent = $('.js-gtm-buy');
        },

        initEvents() {
            $document.on('click', '.js-gtm-salon-locator-link', this.addEventWhereToBy.bind(this));
            $document.on('salonLocator:find', this.addEventFindSalon.bind(this));
            $body.on('click', '.js-gtm-footer-nav-link', this.addEventFooterNavClick.bind(this));
            $body.on('click', '.js-gtm-store-logo', this.addEventStoreLogoClick.bind(this));
            $body.on('click', '.js-gtm-btn-click', this.addEventBtnClick.bind(this));
            $body.on('click', '.js-gtm-file-download', this.addEventFileDownload.bind(this));
            $body.on('click', '.js-gtm-buy', this.addEventBtnBuy.bind(this));
            $body.on('click', '.js-gtm-partner-buy', this.addEventBtnBuyPartner.bind(this)
            );
        },

        addEventWhereToBy(e) {
            e.preventDefault();

            dataLayer.push({
                event: 'uaevent',
                event_name: 'where_to_buy',
                eventAction: 'where to buy',
                eventCategory: 'Ecommerce',
                eventLabel: 'all stores',
                store_name: 'all stores',
            });

            window.location.href = $(e.currentTarget).attr('href');
        },

        addEventFooterNavClick(e) {
            gtm.pushMenuNavigation('footer', $(e.currentTarget).text());
        },

        addEventFindSalon(e, query){
            let eventCategory= 'salon_locator',
                eventAction= 'find a salon',
                eventName = 'salon_locator';
            if (window.locationKey === 'sale_points') {
                eventCategory = 'store_locator';
                eventAction = 'find a store';
                eventName = 'store_locator';
            }

            dataLayer.push({
                event: 'uaevent',
                eventCategory: eventCategory,
                eventAction: eventAction,
                eventLabel: query,
                event_name: eventName,
                search_keyword: query,
            });
        },

        addEventBtnBuy(e) {
            const $target = $(e.currentTarget);
            const $product = $target.parents(this.blockProductAnalytics).length
                ? $target.parents(this.blockProductAnalytics)
                : $target.siblings(this.blockProductAnalytics);

            if (!$product.data('gtm-product')) {
                return;
            }

            const productData = $product.data('gtm-product');

            const gtmEvent = {
                event: 'uaevent',
                eventCategory: 'Ecommerce',
                eventAction: 'click to buy',
                eventLabel: `${productData.name}::${productData.id}`,
                event_name: 'buy_now',
                product_info: `${productData.name}::${productData.id}`,
            };

            this._pushDataLayerEvent(gtmEvent, null, undefined);

            this.$btnCurrent = $target;
        },

        addEventBtnBuyPartner(e) {
            const $target = $(e.currentTarget);
            const $product = this.$btnCurrent.parents(
                this.blockProductAnalytics
            ).length
                ? this.$btnCurrent.parents(this.blockProductAnalytics)
                : this.$btnCurrent.siblings(this.blockProductAnalytics);

            if (!$product.data('gtm-product')) {
                return;
            }

            const storeName = $target.data('partner-label'),
                productData = $product.data('gtm-product');
            delete productData.list;
            productData.quantity = 1;

            const gtmEvent = {
                event: 'addToCart',
                eventCategory: 'Ecommerce',
                eventAction: `redirection::${storeName}`,
                eventLabel: `${productData.name}::${productData.id}`,
                event_name: 'add_to_cart',
                step: 'redirection',
                product_info: `${productData.name}::${productData.id}`,
                store_name: storeName,
            };

            this._pushDataLayerEvent(gtmEvent, 'add', {
                products: [productData],
            });
        },

        addEventStoreLogoClick() {
            gtm.pushStoreLogoNavigation();
        },

        addEventBtnClick(e) {
            const data = $(e.currentTarget).data('gtm-btn-click');

            gtm.pushBtnClick(data.category, data.title, data.name, data.url);
        },

        addEventFileDownload(e) {
            const data = $(e.currentTarget).data('gtm-file-download');

            if (!data.url) {
                return;
            }

            const file = data.url.split('/').pop();

            const name = file.split('.').shift().toLowerCase();
            const type = file.split('.').pop().toLowerCase();

            gtm.pushFileDownload(name, type);
        },

        _pushDataLayerEvent: function (event, block, obj) {
            event.ecommerce = {};

            if (block) {
                event.ecommerce[block] = obj;
                if (window.dlCurrencyCode) {
                    event.ecommerce['currencyCode'] = window.dlCurrencyCode;
                }
            } else {
                event.ecommerce = obj;
            }

            dataLayer.push(event);
        },

        getProduct: function () {
            const $form = $('form[data-product-sku]'),
                productsData = $('.product-info-action').data('gtm-product'),
                productSku = $form.data('product-sku');

            let productData = productsData;
            if ($body.hasClass('page-product-configurable')) {
                productData = {};

                $.each(productsData, (i, data) => {
                    if ($.isEmptyObject(productData) || data.id === productSku) {
                        productData = data;
                    }
                });
            }

            return productData;
        },
    };
});
